/**
 * Created by Jan on 21/04/17.
 */
require("script-loader!Libs/bootstrap/bootstrap-3.3.7-dist/js/bootstrap.js");
require("Libs/bootstrap/bootstrap-3.3.7-dist/css/bootstrap.css");



// WEBPACK FOOTER //
// ./app/libs/bootstrap/bootstrap.js